import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../../messages/en.json';
import zhTranslation from '../../messages/zh.json';
import deTranslation from '../../messages/de.json';

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      zh: {
        translation: zhTranslation,
      },
      de: {
        translation: deTranslation,
      },
    },
    lng: localStorage.getItem('language') || 'en', // Default English; use saved language only after user has switched
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
